export const ASSESSMENT_TOGGLE_LOADING = 'ASSESSMENT_TOGGLE_LOADING'
export const ASSESSMENT_UPDATE_CURRICULUM = 'ASSESSMENT_UPDATE_CURRICULUM'
export const ASSESSMENT_UPDATE_CURRICULUM_METHOD = 'ASSESSMENT_UPDATE_CURRICULUM_METHOD'
export const ASSESSMENT_UPDATE_ERROR = 'ASSESSMENT_UPDATE_ERROR'
export const ASSESSMENT_CURRENT_CURRICULUM = 'ASSESSMENT_CURRENT_CURRICULUM'
export const ASSESSMENT_SET_CURRENT_LEARNING_AREA = 'ASSESSMENT_SET_CURRENT_LEARNING_AREA'

export const toggleLoadingAssessmentCurriculum = (loading = false) => ({
  type: ASSESSMENT_TOGGLE_LOADING,
  payload: { loading }
})

export const updateAssessmentCurriculum = (curriculum = []) => ({
  type: ASSESSMENT_UPDATE_CURRICULUM,
  payload: { curriculum }
})
export const updateAssessmentCurriculumMethod = (method, curriculum = {}) => ({
  type: ASSESSMENT_UPDATE_CURRICULUM_METHOD,
  payload: { method, curriculum }
})

export const updateErrorAssessmentCurriculum = (error = null) => ({
  type: ASSESSMENT_UPDATE_ERROR,
  payload: { error }
})

export const setCurrentCurriculum = (curriculumId) => ({
  type: ASSESSMENT_CURRENT_CURRICULUM,
  payload: { curriculumId }
})

export const setCurrentLearningArea = (learningAreaId) => ({
  type: ASSESSMENT_SET_CURRENT_LEARNING_AREA,
  payload: { learningAreaId }
})
